import { FC } from 'react';
import { container } from 'system/registry';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { Outlet } from 'react-router-dom';
import { LoadingProvider } from 'application/contexts/useLoading';
import { ScrollToTop } from 'ui/components/layouts/ScrollToTop';
import { LocationTracker } from 'application/hooks/useLocationTracker';

const ContextConfig: FC = () => {
    return (
        <LoadingProvider>
            <LocationTracker />
            <diContainerContext.Provider value={container}>
                <ScrollToTop />
                <Outlet />
            </diContainerContext.Provider>
        </LoadingProvider>
    );
};

export default ContextConfig;
